<template>
  <footer
    class="footer"
  >
    <div class="container">
      <div v-if="footerTheme.custom">
        <div v-html="footerTheme.html"></div>
      </div>
      <div v-if="!footerTheme.custom" class="footerContent">
        <div v-if="footerTheme.standard.links.length">
          <div v-for="link of footerTheme.standard.links" :key="link.text">
            <div v-if="link.show">
              <div v-if="link.type === 'Text'">
                <a v-if="link.link.length" :href="link.link">
                  {{ link.text }}
                </a>
                <div v-if="!link.link.length && link.text.length">
                  {{ link.text }}
                </div>
              </div>
            </div>
            <div v-if="link.type === 'HTML'">
              <div v-html="link.html"></div>
            </div>
          </div>
        </div>
        <div
          v-if="footerTheme.standard.logos.length"
          style="display: flex;justify-content: center;align-items: center;"
        >
          <div v-for="logo of footerTheme.standard.logos" :key="logo.url">
            <a v-if="logo.link.length" :href="logo.link">
              <img
                v-if="logo.show"
                :src="logo.url"
                :alt="logo.alt"
                :title="logo.title"
                :style="{ 'max-height': logo.height || '52px' }"
                style="margin: 12px;"
              />
            </a>
            <img
              v-if="logo.show && !logo.link.length"
              :style="{ 'max-height': logo.height || '52px' }"
              style="margin: 12px;"
              :src="logo.url"
              :alt="logo.alt"
              :title="logo.title"
            />
          </div>
        </div>
      </div>
      <div class="copyright">
        &#169; Copyright
        <a target="_blank" href="https://pipelineroi.com">Pipeline ROI</a>
        {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>
import { getSiteFooter } from "../services/theme";
export default {
  name: "MainFooter",
  data() {
    return {
      background: this.$theme.background,
      footerTheme: {
        html: "",
        custom: false,
        standard: {
          logos: [],
          links: [],
        },
      },
      year: new Date().getFullYear(),
    };
  },
  async created() {
    this.getFooterTheme();
    window.addEventListener("theme", () => {
      this.background = this.$theme.background;
    });
  },
  methods: {
    async getFooterTheme() {
      let footer = await getSiteFooter();
      this.footerTheme = footer.data;
      setTimeout(() => {
        let fth = document.querySelector("footer");
        if (fth.offsetHeight > 130) {
          fth.style = `bottom: -${fth.offsetHeight-130}px;` + `background-color: ${this.background} !important`;
        } else {
          fth.style = `background-color: ${this.background} !important`
        }
      });
    },
  },
};
</script>
<style>
.footer {
  width: 100%;
  padding: 1rem 0;
  position: absolute;
  bottom: 0;
}
.footerContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.copyright {
  font-size: 14px;
  text-align: center;
}
@media (max-width: 575px) {
  .footer {
  width: 100%;
  padding: 1rem 0;
  position: relative;
  bottom: 0;
}
}
</style>
